import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import WhistleProNavigation from '../components/navigation/whistlepro-navbar'
import MobileNavigation from '../components/navigation/MobileNavigation'
import GlassFooter from '../components/layout/GlassFooter'
import { useTheme } from '../contexts/ThemeContext'

const PublicLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { theme, toggleTheme } = useTheme()
  const [activeNav, setActiveNav] = useState('dashboard')
  
  // Map routes to nav IDs
  useEffect(() => {
    const pathname = location.pathname
    if (pathname === '/') {
      setActiveNav('dashboard')
    } else if (pathname === '/pricing') {
      setActiveNav('pricing')
    } else if (pathname === '/lookup' || pathname.startsWith('/case/')) {
      setActiveNav('analytics')
    } else if (pathname === '/auth/login') {
      setActiveNav('settings')
    }
  }, [location])
  
  const handleNavChange = (navId: string) => {
    switch (navId) {
      case 'dashboard':
        navigate('/')
        break
      case 'pricing':
        navigate('/pricing')
        break
      case 'analytics':
        navigate('/lookup')
        break
      case 'settings':
        navigate('/auth/login')
        break
    }
  }
  
  const handleGetStarted = () => {
    navigate('/pricing')
  }
  
  const handleLogoClick = () => {
    window.location.href = '/'
  }
  
  return (
    <div className="min-h-screen flex flex-col">
      {/* Desktop Navigation */}
      <div className={`responsive-hide-xs fixed top-0 left-0 right-0 z-50 pt-6 pb-6 backdrop-blur-sm ${
        theme === 'dark' 
          ? 'bg-gradient-to-b from-gray-900/80 via-purple-900/50 to-transparent' 
          : 'bg-gradient-to-b from-blue-50/80 via-purple-50/50 to-transparent'
      }`}>
        <WhistleProNavigation 
          onNavChange={handleNavChange}
          onGetStarted={handleGetStarted}
          onLogoClick={handleLogoClick}
          defaultActiveNav={activeNav}
          theme={theme}
          onThemeToggle={toggleTheme}
        />
      </div>
      
      {/* Mobile Navigation */}
      <div className="responsive-show-xs">
        <MobileNavigation 
          theme={theme}
          onThemeToggle={toggleTheme}
        />
      </div>
      
      <main className="flex-grow w-full">
        <Outlet />
      </main>
      
      <GlassFooter />
    </div>
  )
}

export default PublicLayout